jQuery(once('cm-newsletter', 'body')).on('submit', '#newsletterSignup', function (event) {
    event.preventDefault();
    var tokenAccessCode = "E03859418-FRM3T2CON4";
    var isFormValid = true;
    var fieldNamesWithValues = [];

    jQuery('#newsletterSignup input').each(function () {
        var emailAddress = jQuery.trim($(this).val());
        var isRequired = $(this).attr("data-isrequired") !== null;

        if (isRequired && emailAddress.trim() === '') {
            alert($(this).attr("data-actualname") + " is a required field");
            jQuery(this).focus();
            isFormValid = false;
            return false;
        } else {
            fieldNamesWithValues.push({
                CustomFieldID: $(this).attr("name"),
                FieldValue: emailAddress,
                ActualName: $(this).attr("data-actualname"),
                ActualFieldName: $(this).attr("data-actualname"),
                Type: $(this).attr("type"),
                Required: isRequired
            });
        }
    });

    if (isFormValid) {
        var url = "https://extsub.cmadvantage.co.uk/ExternalResourceService.asmx";
        jQuery.ajax({
            type: "POST",
            url: url + "/SubscriberFormSubmit",
            data: JSON.stringify({
                FormFieldDetails: fieldNamesWithValues,
                tokenAccessCode: tokenAccessCode
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: OnSuccessCall,
            error: OnErrorCall
        });
    }
});

function OnSuccessCall(response) {
    jQuery('#nlFormMsgError').hide('fast');
    jQuery('#nlFormMsgSuccess').hide('fast');

    const responseMessage = response.d.trim().toLowerCase();

    if (responseMessage.includes('error:')) {
        if (responseMessage.includes('email address already exists')) {
            const emailAlreadyUsedMessage = 'We could not complete your registration with this email address, please try a different one or contact us.';
            jQuery('#nlFormMsgError').text(emailAlreadyUsedMessage).show('fast');
        } else {
            jQuery('#nlFormMsgError').show('fast');
        }
    } else {
        jQuery('#nlFormMsgSuccess').show('fast');
    }
}

function OnErrorCall(request, error) {
    jQuery('#nlFormMsgError').show('fast');
}
